import { doAjax } from './helper'

const initResetModal = () => {
	const modalToggle = document.querySelector('#reset-config')
	const modal = document.querySelector('#reset-modal')
	const cancel = modal?.querySelector('.cancel')
	const close = modal?.querySelector('.close')
	const submit = modal?.querySelector('.submit')

	modalToggle?.addEventListener('click', (e) => {
		modal?.classList.remove('hidden')
		e.preventDefault()
	})

	submit?.addEventListener('click', (e) => {
		e.preventDefault()
		doAjax({ 'reset_config_modal': true }, (response) => {
			if (response?.success) {
				document.getElementById('loading-screen').classList.add('loading')
				location.href = location.href
			}
		});
		modal.classList.add('hidden')
	})

	cancel?.addEventListener('click', (e) => {
		modal.classList.add('hidden')
	})
	close?.addEventListener('click', (e) => {
		modal.classList.add('hidden')
	})
	modal?.addEventListener('click', (e) => {
		modal.classList.add('hidden')
	})
	modal?.querySelector('.modal-inner').addEventListener('click', (e) => {
		e.stopPropagation()
	})
}

export { initResetModal }
